import React, {useEffect, useRef} from "react";
import gsap from "gsap";

//Images

import TitleBG from "../images/background-03.jpg";
import TitleBGRet from "../images/background-03@2x.jpg";
import TitleBGWebp from "../images/background-03.webp";
import TitleBGWebpRet from "../images/background-03@2x.webp";


import src01 from "../images/image3_1-01.jpg";
import src01Ret from "../images/image3_1-01@2x.jpg";
import webp01 from "../images/image3_1-01.webp";
import webp01Ret from "../images/image3_1-01@2x.webp";

import src02 from "../images/image3_2-01.jpg";
import src02Ret from "../images/image3_2-01@2x.jpg";
import webp02 from "../images/image3_2-01.webp";
import webp02Ret from "../images/image3_2-01@2x.webp";

import src03 from "../images/image3_2-02.jpg";
import src03Ret from "../images/image3_2-02@2x.jpg";
import webp03 from "../images/image3_2-02.webp";
import webp03Ret from "../images/image3_2-02@2x.webp";

import src04 from "../images/image3_3-01.jpg";
import src04Ret from "../images/image3_3-01@2x.jpg";
import webp04 from "../images/image3_3-01.webp";
import webp04Ret from "../images/image3_3-01@2x.webp";

import src05 from "../images/image3_4-01.jpg";
import src05Ret from "../images/image3_4-01@2x.jpg";
import webp05 from "../images/image3_4-01.webp";
import webp05Ret from "../images/image3_4-01@2x.webp";

import src06 from "../images/image3_5-01.jpg";
import src06Ret from "../images/image3_5-01@2x.jpg";
import webp06 from "../images/image3_5-01.webp";
import webp06Ret from "../images/image3_5-01@2x.webp";

import src07 from "../images/image3_6-01.jpg";
import src07Ret from "../images/image3_6-01@2x.jpg";
import webp07 from "../images/image3_6-01.webp";
import webp07Ret from "../images/image3_6-01@2x.webp";

import srcArticle from "../images/article-02.jpg";
import srcArticleRet from "../images/article-02@2x.jpg";
import webpArticle from "../images/article-02@2x.jpg";
import webpArticleRet from "../images/article-02@2x.webp";

import styles from "./Section03.module.scss";

import Content from "./Elements/Content";
import Title from "./Elements/Title"
import Block from "./Elements/Block";
import Image from "./Global/Image";

import ImageText from "./Elements/ImageText";
import Quote from "./Elements/Quote";
import ArticleLink from "./Elements/ArticleLink";
import isMobile from "ismobilejs";

export default function Section03() {
    const sectionTitle = `Nouveau contrat social`;
    const ad_container = useRef(null);


    useEffect(() => {
        const ad = document.querySelector('.dcmads iframe');
        gsap.set('.dcmads', {
            display: 'none'
        });

        if (ad) {
            ad_container.current.innerHTML = ad.outerHTML;
        }


    }, []);
    return (
        <Content classname={'navigation--1'}>
            <Title title={sectionTitle} numero={3}
                   background={{src: TitleBG, srcRet: TitleBGRet, webp: TitleBGWebp, webpRet: TitleBGWebpRet}}/>

            <Block title={'Les défis RH'} number={3.1} sectionTitle={sectionTitle} container={true}
                   classname={'navigation--2'}>
                <p className={'size-5 ml-4'}>
                    Plus qu'une évolution, le déploiement du télétravail à grande échelle implique une véritable
                    révolution en termes juridiques et de droit du travail. Télétravailler signifie travailler depuis
                    chez soi, dans un espace de co-working ou en mode nomade... Ce qui n'est pas forcément la même chose
                    pour le département juridique de votre entreprise en termes contractuel d'organisation ou
                    d'assurance ! Juridiquement, le télétravail doit donc être mis en place soit dans le cadre d'un
                    accord collectif, soit à titre individuel ou exceptionnel. Dans le cas de négociations menées entre
                    les partenaires sociaux (employeurs et salariés), ces changements profonds d'habitude de travail
                    peuvent d'inscrire dans le cadre d'une charte élaborée par l'employeur, après avis du CSE. En
                    l'absence de charte ou d'accord collectif, lorsque le salarié et l'employeur conviennent de recourir
                    au télétravail, ils doivent formaliser leur accord noir sur blanc.
                </p>

                <Image classname={[styles.Image, 'size-8'].join(' ')}
                       src={src01} srcRet={src01Ret} webp={webp01} webpRet={webp01Ret}
                       radius={true}/>

                <p className={'size-5 ml-4'}>
                    Il existe plusieurs formes de télétravail : le télétravail régulier ou bien le télétravail
                    occasionnel. En cas de circonstances exceptionnelles, comme depuis deux ans avec l'épidémie de
                    covid-19 par exemple, le télétravail peut être imposé sans l'accord des salariés. Ces mesures
                    peuvent être prises pour permettre la continuité de l'activité et garantir la protection des
                    travailleurs.
                </p>
            </Block>

            <Block title={`L’organisation du travail`} number={3.2} sectionTitle={sectionTitle}
                   classname={'navigation--2'}>
                <div className="container">
                    <ImageText image={{src: src02, srcRet: src02Ret, webp: webp02, webpRet: webp02Ret}} radius={true}
                               classname={'rtl with--margin large'}>
                        <p>
                            L'accord collectif ou la charte élaborée par l'employeur doit préciser les éléments suivants
                            : postes éligibles au télétravail, conditions de passage en télétravail et de retour à une
                            exécution du contrat de travail en présentiel. Le télétravailleur est même prioritaire pour
                            occuper ou reprendre un poste sans télétravail qui correspond à ses qualifications et
                            compétences professionnelles. Son employeur est tenu et de porter à sa connaissance la
                            disponibilité de tout poste de cette nature. A l'inverse, le refus d'accepter de passer en
                            télétravail n'est pas un motif de rupture du contrat de travail...
                        </p>
                    </ImageText>

                    <ImageText image={{src: src03, srcRet: src03Ret, webp: webp03, webpRet: webp03Ret}} radius={true}
                               classname={'with--margin-image large'}>
                        <p>
                            Il faut aussi déterminer le mode d'acceptation par le salarié des conditions de mise en
                            oeuvre du télétravail, les moyens de contrôle du temps de travail ou de régulation de la
                            charge de travail, mais aussi les plages horaires durant lesquelles l'employeur peut
                            habituellement contacter le salarié en télétravail. L'employeur qui refuse d'accorder le
                            télétravail à un salarié occupant un poste « télétravaillable », dans les conditions prévues
                            par accord collectif ou par charte, doit toujours motiver sa réponse. Si un accord est
                            trouvé, les droits et devoirs du salariés sont les mêmes que pour l'employé sur site :
                            L'employeur doit organiser chaque année un entretien qui porte notamment sur les conditions
                            d'activité du salarié et sa charge de travail. Le télétravailleur bénéficie ainsi des mêmes
                            droits individuels et collectifs que les autres salariés : Accès à la formation, respect de
                            la vie privée, droit à la déconnexion, respect de la santé et de la sécurité au travail,
                            accès aux activités sociales de l'entreprise, aux informations syndicales, aux avantages
                            sociaux...
                        </p>
                    </ImageText>

                    <p className={'size-6 ml-1'}>
                        Un accident corporel survenu sur le lieu où se pratique le télétravail pendant l'exercice de
                        l'activité professionnelle du télétravailleur est présumé être un accident du travail. Moins
                        visible mais bien réel, le risque de burnout est à considérer sérieusement selon les dernières
                        études parues sur le sujet à l'occasion de l'épidémie de Covid-19. Parmi les sujets sensibles
                        qui concernent le télétravail, le droit à la déconnexion figure d'ailleurs en bonne place : en
                        dehors de ses heures de travail, tout salarié n'est pas tenu d'être en permanence joignable par
                        son employeur pour des motifs liés à l'exécution de son travail. Dans le cadre du télétravail,
                        mis en place de façon exceptionnelle ou non, le droit à la déconnexion s'applique également...
                        Cependant, les modalités de ce droit doivent être prévues par l'entreprise. Instauré par la loi
                        dite " Loi travail " du 8 août 2016, le droit à la déconnexion est en vigueur depuis le 1er
                        janvier 2017. Il est consacré à l'article L. 2242-17 du Code du travail.
                    </p>
                </div>
            </Block>

            <Block title={`Besoins de formation`} number={3.3} sectionTitle={sectionTitle} classname={'navigation--2'}
                   background={'black'} color={'white'} container={true}>
                <ImageText image={{src: src04, srcRet: src04Ret, webp: webp04, webpRet: webp04Ret}} radius={true}
                           classname={'rtl small pl-1'}>
                    <p>
                        Pour éviter ce genre de mésaventures, depuis 2005, une formation de base est obligatoire pour le
                        salarié en télétravail... Selon l'article 10 de l'Accord Interprofessionnel du 19 juillet 2005
                        étendu par décret par l'Arrêté du 30 mai 2006 (JO du 9 juin), les télétravailleurs ont le même
                        accès à la formation et aux possibilités de déroulement de carrière que des salariés en
                        situation comparable qui travaillent dans les locaux de l'employeur. Les télétravailleurs
                        reçoivent, en outre, une formation appropriée, ciblée sur les équipements techniques à leur
                        disposition et sur les caractéristiques de cette forme d'organisation du travail. Le responsable
                        hiérarchique et les collègues directs des télétravailleurs doivent également pouvoir bénéficier
                        d'une formation à cette forme de travail et à sa gestion. "
                    </p>
                    <p>
                        Depuis plusieurs années, de nombreux modules de formation ont vu le jour avec le développement
                        rapide du travail à distance. " Il faut qu'on le veuille ou non apprendre à travailler à
                        distance, aussi bien avec ses collègues, ses clients ou ses fournisseurs " estiment les
                        spécialistes. Si les outils de communication sont nombreux, la façon de se comporter sur une
                        plateforme en ligne, par mail ou par messagerie n'est en rien comparable avec un contact
                        physique direct ! Attention donc aux malentendus, aux incompréhensions ou aux désaccords nés
                        d'une mauvaise communication...
                    </p>
                    <p>
                        Travailler de façon autonome n'est pas inné, et même contre-nature pour de nombreux salariés :
                        S'organiser, planifier son travail, ou se motiver peut être plus facile dans une ambiance de
                        travail, d'où l'intérêt des plateformes collaboratives. Si cela ne suffit pas, les espaces de
                        coworking peuvent aussi pallier certains manques.
                    </p>
                </ImageText>
            </Block>

            <Block title={`Le co-working, ou le « télétravail partagé »`} number={3.4} sectionTitle={sectionTitle}
                   classname={'navigation--2'} container={true}>
                <p className={'size-5 ml-2'}>
                    Partager, brainstormer, collaborer, inventer... L'espace de co-working doit être capable de proposer
                    des espaces privatifs, mais aussi des lieux de vie qui donnent envie de faire circuler
                    l'information. Lieux d'innovation, de partage d'expertises, les salles de réunions sont souvent
                    ouvertes, les rooftops aérés et les auditoriums faciles à réserver sur son smartphone ! Gérer en
                    continu un flux de télétravailleurs, c'est le lot des espaces de coworking : il convient donc
                    d'optimiser les mètres carrés en gardant à l'esprit que du lundi au mardi par exemple, deux fois
                    plus de monde peut être susceptible de fréquenter un espace de co-working. Rien n'est jamais figé ni
                    définitif !
                </p>

                <ImageText image={{src: src05, srcRet: src05Ret, webp: webp05, webpRet: webp05Ret}} radius={true}
                           classname={'large'}>
                    <p>
                        Concrètement, les espaces de co-working se sont multipliés ces dernières années : chez WeWork,
                        la stratégie passe par des tarifs préférentiels, de la flexibilité, du bien vivre avec des «
                        happy hours », le café gratuit... Le groupe américain dispose désormais d'une vingtaine
                        d'adresses à Paris. Morning, de son côté, réaménage en permanence ses espaces de travail en
                        restant à l'écoute des utilisateurs pour coller aux besoins en temps réel de ses clients.
                        Meubles sur mesure, bureaux novateurs pour travailler debout, éclairage pré-programmé, connexion
                        hyper sécurisée... la liste est longue ! Wework comme Morning misent sur l'ultra-proximité pour
                        séduire les salariés nomades. Loin des « hyper-centres », Stop and Work (groupe IWC) investit
                        massivement en (grande) banlieue parisienne (Alfortville, Cergy ou encore Fontainebleau). Plus
                        loin, en Haute-Savoie, Entrelac espère attirer les télétravailleurs isolés grâce à son
                        emplacement et son investissement sur le plan local. Quant à W'iN, ce dernier mise sur les
                        territoires. Présent dans de grandes villes comme Bordeaux ou Nantes, le groupe cible les petits
                        espaces installés dans des monuments historique et sillonne les régions pour faire revivre les
                        centres-villes délaissés de leurs commerces et vidés de leur substance...
                    </p>
                </ImageText>


                <div ref={ad_container} style={{
                    width: isMobile().phone ? 300 : 920,
                    height: isMobile().phone ? 600 : 250,
                    margin: '50px auto 0'
                }}/>
            </Block>

            <Block title={`L'immobilier sens dessus dessous !`} number={3.5} sectionTitle={sectionTitle}
                   classname={'navigation--2'} container={true}>
                <p className={'size-6 ml-3'}>
                    Repeupler les régions désertées depuis trop longtemps, voilà l'occasion unique de rééquilibrer les
                    territoires ! Le marché immobilier en a déjà tiré les conséquences : une étude Harris Interactive
                    pour RTL et le réseau d'agences Stéphane Plaza Immobilier réalisée fin 2021 montre que 26% des
                    Français souhaitent encore déménager vers une commune rurale cette année (contre 30% en 2021) ou à
                    la campagne et 14% veulent s'éloigner du centre-ville pour vivre dans une zone "moins urbanisée".
                    Plusieurs régions ont déjà vu les prix de l'immobilier sensiblement augmenter depuis deux ans sous
                    l'effet de cette nouvelle demande : la Bretagne, la Nouvelle-Aquitaine, l'Occitanie, la région
                    Provence-Alpes-Côte d'Azur et l'Auvergne-Rhône Alpes. Le site internet spécialiste de l'immobilier
                    Seloger a fait le point sur les villes où les prix ont profité de l'envolée de la demande : très
                    prisée des parisiens qui n'ont plus peur de s'éloigner professionnellement de la capitale, Biarritz
                    flirte avec les 7.000 euros/m2, tout comme Annecy, des prix qui n'ont rien à envier à ceux qui se
                    pratiquent dans certaines grandes villes comme Lyon, Nice ou Bordeaux. Moins loin de Paris, parmi
                    les "chouchous des télétravailleurs" on peut citer Tours ou encore Le Mans.
                </p>

                <Image classname={[styles.Image, 'size-7'].join(' ')}
                       src={src06} srcRet={src06Ret} webp={webp06} webpRet={webp06Ret}
                       radius={true}/>

                <p className={'size-5 ml-5'}>
                    Si le Medef a émis quelques réserves dernièrement sur le travail à distance et ses effets
                    psychologiques à long terme, selon l'Institut Sapiens, qui s'est penché sur les conséquences des
                    évolutions liées à la révolution numérique, le télétravail a entraîné, selon " une hypothèse basse
                    ", une hausse de la productivité des salariés de 22 %. Ce qui s'explique entre autres par une
                    augmentation des temps de travail et de sommeil, une réduction des temps de trajet ou " une forte
                    réduction des réunions inutiles et chronophages qui nuisent à la productivité ".
                </p>

            </Block>

            <Block title={`Le métaverse : l’avenir du télétravail ?`} number={3.6} sectionTitle={sectionTitle}
                   classname={'navigation--2'} container={true}>
                <div className={['row', styles.Row].join(' ')}>
                    <div className={'size-4'}>
                        <p>
                            Considéré comme l’un des grands défis des GAFAM et autres acteurs du jeu vidéo, le métaverse
                            a de fortes chances de révolutionner les pratiques en milieu professionnel, et notamment
                            favoriser davantage le télétravail. Alors qu’il connaît un regain d’intérêt ces derniers
                            temps, et notamment depuis que Facebook s’est rebaptisé « Meta » et a annoncé son ambition
                            de devenir un acteur majeur du prochain grand saut dans l'évolution d'Internet, ce concept
                            d’univers numérique parallèle pourrait, par exemple, offrir la possibilité d’effectuer les
                            réunions à distance entre employés tout en ayant l’impression d’être dans le même bureau.
                            Les espaces 3D dans le métavers de Meta doivent permettre de « de tisser des liens,
                            d’apprendre, de jouer de manières encore inimaginables », mais aussi de « collaborer »,
                            avait indiqué le géant des réseaux sociaux.
                        </p>
                    </div>

                    <div className={'size-6 pl-1'}>
                        <Image classname={[styles.Image].join(' ')}
                               src={src07} srcRet={src07Ret} webp={webp07} webpRet={webp07Ret}
                               radius={true}/>

                        <p>
                            Ainsi, dans le futur, nous nous retrouverons probablement avec nos collègues dans une salle
                            de réunion qui pourrait être reconstituée virtuellement afin de se rapprocher un peu plus de
                            la réalité que la simple visio-conférence telle qu'elle est pratiquée actuellement. Même un
                            médecin pourra opérer une chirurgie avec l'aide des mondes virtuels.
                        </p>

                        <p>
                            Dans sa rétrospective personnelle de 2021, publiée dans son blog en décembre dernier, Bill
                            Gates a partagé ses réflexions sur l’avenir du télétravail et la façon dont sa pratique
                            pourrait changer avec la montée du métaverse. L’ancien PDG de Microsoft estime que le monde
                            du travail sera le premier à bénéficier des fonctionnalités offertes par le métaverse.
                        </p>
                    </div>
                </div>

                <Quote sourceName={'Bill Gates '} sourceText={'dans « Gates Notes », décembre 2021'}>
                    D’ici deux ou trois ans, je prédis que la plupart des réunions virtuelles passeront d’un affichage caméra en grille et en 2D – que j’appelle le modèle Hollywood Squares [en référence à un jeu télévisé américain], bien que je sache que cela ne me rajeunit pas – au métavers, un espace en 3D avec des avatars numériques
                </Quote>

                <ArticleLink title={`Télétravail : pourquoi la France va rattraper son retard !`} href={'https://www.boursier.com/dossiers/travail-a-distance-avec-etoro/economie/teletravail-pourquoi-la-france-va-rattraper-son-retard-47782.html'} image={{src: srcArticle, srcRet: srcArticleRet, webp: webpArticle, webpRet: webpArticleRet}}/>
            </Block>
        </Content>
    )
}
